import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import Layout from "../components/organisms/Layout";
import WrapperFaqs from "../components/atoms/WrapperFaqs";
import AccordionList from "../components/atoms/AccordionList";

const guias = () => {
	return (
		<Layout>
			<WrapperFaqs>
				<div className='container'>
					<div className='row justify-content-center'>
						<div className='col-md-12 col-lg-6 text-center'>
							<h1>Guías y Recomendaciones</h1>
							<p className='mb-4'>
								¿Necesitas ayuda para saber qué seguro adquirir? Por favor,
								revisa la siguiente guía y recomendaciones.
							</p>
							<p>Nuestros Gurús en Tranquilidad te guiarán.</p>
						</div>
					</div>
					<div className='row align-items-center'>
						<div className='col-md-12'>
							<div className='card text-center'>
								<TabsAccordionList />
							</div>
						</div>
					</div>
				</div>
			</WrapperFaqs>
		</Layout>
	);
};
const TabsAccordionList = () => {
	const [key, setKey] = useState("seguro");
	return (
		<Tabs
			id='controlled-tab-example'
			activeKey={key}
			onSelect={(k) => setKey(k)}
			className='mb-3 card-header'>
			<Tab eventKey='seguro' title='SEGURO DE AUTO'>
				<AccordionList array={SEGURO} />
			</Tab>
			<Tab eventKey='auto' title='AUTO'>
				<AccordionList array={AUTO} />
			</Tab>
			<Tab eventKey='accidentes' title='ACCIDENTES PERSONALES/INFARTO'>
				<AccordionList array={ACCIDENTES} />
			</Tab>
			<Tab eventKey='hogar' title='HOGAR'>
				<AccordionList array={HOGAR} />
			</Tab>
		</Tabs>
	);
};

const SEGURO = [
	{
		key: "0",
		header: "Descripción de Producto",
		body: (
			<>
				<h3>Cobertura Amplia </h3>
				<p>
					Si lo que tu necesitas es proteger tu patrimonio, este paquete es el
					adecuado para ti, ya que cubriría la reparación de tu auto en caso de
					siniestro, ademas de amparar el robo y responsabilidad civil que
					pudieran derivarse de algún accidente.
				</p>
				<h3>Cobertura Limitada</h3>
				<p>
					Si a ti lo que te preocupa es solamente el robo de tu auto y los
					gastos que se generen a partir de daños a terceros este paquete es el
					adecuado para ti. Si sufrieras el robo del auto, la aseguradora te
					pagará el valor comercial, es decir, el valor de venta en el momento
					del siniestro. Este paquete no contempla la cobertura de daños
					materiales, por lo que todo daño ocasionado a tu auto correrá por tu
					cuenta.
				</p>
				<h3>Cobertura Responsabilidad Civil</h3>
				<p>
					Si a ti te preocupan solamente los daños que puedas causar a terceros,
					este paquete es el adecuado para ti. Incluye la suma asegurada
					suficiente y generalmente te alcanzará para pagar cualquier daño que
					causes a terceros en sus bienes o personas. Este paquete no cubre los
					daños ocasionados a tu auto ni te pagará si tu auto es robado.Te
					invitamos a comparar el paquete de Responsabilidad Civil con el
					Limitado, por unos cuantos pesos más, podrías estar asegurado contra
					robo.
				</p>
				<h3>Paquete Básico</h3>
				<p>
					Con este paquete estas en regla según la actual ley que exige la
					adquisición de un seguro de Responsabilidad Civil. Sin embargo, te
					invitamos a comparar el paquete básico con el de Responsabilidad
					Civil, la realidad es que la suma asegurada del paquete básico es muy
					baja y probablemente en caso de que causes daños a tercero en sus
					bienes o personas no te alcanzará el importe que ofrece. Evita
					sorpresas y por 15% más obtén la cobertura de RC más completa.
				</p>
			</>
		),
	},
	{
		key: "1",
		header: "Comprar (emitir póliza)",
		body: (
			<>
				<p>
					Para contratar tu seguro de auto necesitarás cumplir con los
					siguientes requisitos:Tener licencia de conducir vigente.
				</p>
				<p>
					Asegúrate de escoger el paquete adecuado para ti, recuerda que el
					ahorro también consiste en no hacer un fuerte gasto en caso de algún
					siniestro.
				</p>
				<p>
					Revisa que tus datos y los de tu auto coincidan perfectamente antes de
					comprar.
				</p>
				<p>Revisa nuestras promociones.</p>
				<p>
					Resuelve cualquier duda comunicándote con nosotros, contáctanos las
					24hrs los 365 días del año: Lada sin costo 01800-HEYBAJA, chat en
					línea, skype, e-mail contacto@bajatuseguro.com, o a través de nuestras
					redes sociales.
				</p>
			</>
		),
	},
	{
		key: "2",
		header: "Pagar Póliza",
		body: (
			<>
				<p>
					Ten a la mano tu tarjeta de crédito o debito, recuerda que aceptamos
					todas las tarjetas Visa, Mastercard o American Express.
				</p>
				<p>
					Si tu pago es semestral o trimestral puedes solicitar que el cargo sea
					recurrente para que se realice de manera automática, cuando tu lo
					decidas podrás dar de baja este servicio.
				</p>
				<p>
					Recuerda que en caso de forma de pago mensual los cargos recurrentes
					son obligatorios, te sugerimos revisar las promociones a meses sin
					intereses.
				</p>
				<p>
					Ingresa tus datos en el portal y siéntete tranquilo, ya estas
					asegurado.
				</p>
			</>
		),
	},
	{
		key: "3",
		header: "Renovaciones",
		body: (
			<>
				<p>
					En tu renovación, nosotros te enviaremos propuestas para que puedas
					revisar las diferentes opciones que tenemos para ti, podrás
					consultarlas con 30 días de anticipación
				</p>
				<p>
					Si no pudiste revisar tus opciones no te preocupes, nuestra renovación
					es automática, solo deberás confirmarla y pagarla para que de esta
					manera puedas continuar protegido.
				</p>
				<p>
					Baja nuestra app, en ella encontraras notificaciones, calendarios y
					las propuestas para que no se te olvide renovar.
				</p>
				<p>
					*Estas condiciones pueden variar dependiendo la aseguradora que
					elijas.
				</p>
			</>
		),
	},
];
const AUTO = [
	{
		key: "0",
		header: "Descripción de Producto",
		body: "Si a ti te preocupan los daños que puedas causar a terceros, este paquete es el adecuado para ti. Incluye la suma asegurada que te alcanzará para pagar cualquier daño que causes a terceros en sus bienes o personas, Hasta por $3,000,000 de pesos. Este paquete no cubre los daños ocasionados a tu auto, ni te pagará si tu auto es robado.Te invitamos a comparar el paquete de Responsabilidad Civil con el Limitado y Amplio , ya que por unos cuantos pesos más, podrías tener una cobertura más completa.",
	},
	{
		key: "1",
		header: "Comprar (emitir póliza)",
		body: (
			<>
				Para contratar tu seguro de auto necesitarás cumplir con los siguientes
				requisitos:
				<li>Tener licencia de conducir vigente.</li>
				<li>
					Asegúrate de escoger el paquete adecuado para ti, recuerda que el
					ahorro también consiste en no hacer un fuerte gasto en caso de algún
					siniestro.
				</li>
				<li>
					Revisa que tus datos y los de tu auto coincidan perfectamente antes de
					comprar.
				</li>
				<li>Revisa nuestras promociones.</li>
				<li>
					Resuelve cualquier duda comunicándote con nosotros, contáctanos las
					24hrs los 365 días del año: Lada sin costo 01800-HEYBAJA, chat en
					línea, skype, e-mail contacto@bajatuseguro.com, o a través de nuestras
					redes sociales.
				</li>
			</>
		),
	},
	{
		key: "2",
		header: "Pagar Póliza",
		body: (
			<>
				<p>
					Ten a la mano tu tarjeta de crédito o debito, recuerda que aceptamos
					todas las tarjetas Visa, Mastercard o American Express.
				</p>
				<p>
					Si tu pago es semestral o trimestral puedes solicitar que el cargo sea
					recurrente para que se realice de manera automática, cuando tu lo
					decidas podrás dar de baja este servicio.
				</p>
				<p>
					Recuerda que en caso de forma de pago mensual los cargos recurrentes
					son obligatorios, te sugerimos revisar las promociones a meses sin
					intereses.
				</p>
				<p>
					Ingresa tus datos en el portal y siéntete tranquilo, ya estas
					asegurado.
				</p>
			</>
		),
	},
	{
		key: "3",
		header: "Renovaciones",
		body: (
			<>
				<p>
					En tu renovación, nosotros te enviaremos propuestas para que puedas
					revisar las diferentes opciones que tenemos para ti, podrás
					consultarlas con 30 días de anticipación
				</p>
				<p>
					Si no pudiste revisar tus opciones no te preocupes, nuestra renovación
					es automática, solo deberás confirmarla y pagarla para que de esta
					manera puedas continuar protegido.
				</p>
				<p>
					Baja nuestra app, en ella encontraras notificaciones, calendarios y
					las propuestas para que no se te olvide renovar.
				</p>
				<p>
					*Estas condiciones pueden variar dependiendo la aseguradora que
					elijas.
				</p>
			</>
		),
	},
];
const ACCIDENTES = [
	{
		key: "0",
		header: "Descripción de Producto",
		body: (
			<>
				<p>Planes de apoyo y asistencia para GASTOS MÉDICOS</p>
				<p>
					Si ya tienes Seguro Popular, Seguro Social, ISSSTE o una póliza de
					Gastos Médicos por parte de la empresa donde trabajas o de forma
					individual, somos la mejor opción para ti, ya que nuestros planes te
					dan dinero en efectivo con el hecho de enfermarte, sin importar quien
					lo pagó y dónde te atendiste.
				</p>
				<p>
					Porque la Salud no tiene precio y con Dinero los males son menores,
					contamos con precios muy atractivos.
				</p>
				<p>*Para mayor información revisa las condiciones generales.</p>
			</>
		),
	},
	{
		key: "1",
		header: "Comprar (emitir póliza)",
		body: "Para adquirir este seguro debes tener entre 13 y 64 años de edad, ingresar todos tu datos en la solicitud en línea, y realizar tu pago, recuerda que si eres menor de edad debes tener un contratante que sea mayor de edad y especificarlo como el pagador de la póliza.",
	},
	{
		key: "2",
		header: "Pagar Póliza",
		body: "Debes tener a la mano cualquier tarjeta de crédito o debito visa o mastercard, que este previamente liberada por tu banco para compras en línea.",
	},
	{
		key: "3",
		header: "Reclamos (siniestro)",
		body: (
			<>
				En caso de siniestro, debes reportarlo directamente a la compañía de
				seguros, recuerda que no importa en que hospital o institución de salud
				te atiendas, nosotros te indemnizamos. Los documentos que te requerirán
				en cada caso son:
				<h3>ACCIDENTES PERSONALES</h3>
				<p>
					<li>
						Fallecimiento y gastos funerarios
						<li>
							Original o copia certificada del acta de defunción del Asegurado.
						</li>
						<li>
							Copia certificada de las actuaciones ante el Ministerio Público,
							en caso de que la muerte del Asegurado haya sucedido de forma
							violenta.
						</li>
						<li>
							Constancia del médico que acredite que las causas del
							fallecimiento derivaron de un Accidente cubierto.
						</li>
						<li>
							Facturas para solventar los gastos erogados por motivo de sepelio
							o incineración, fosa o nicho y transporte del cadáver o de las
							cenizas del Asegurado.
						</li>
					</li>
					<li>
						Reembolso de gastos médicos por accidente
						<li>
							Constancia o informe del Médico que acredite las lesiones y
							tratamiento como consecuencia del Accidente cubierto, así como las
							fechas en que ocurrió el Accidente y la fecha de la primera
							atención al paciente.{" "}
						</li>
						<li>
							Estudios realizados y que demuestren la (s) lesiones sufridas por
							el Asegurado.
						</li>
						<li>
							Facturas y recibos fiscales de los servicios médicos recibidos,
							dichas facturas deberán estar a nombre del Asegurado, además
							deberán contener el desglose correspondiente de gastos.{" "}
						</li>
					</li>
				</p>
				<h3>INFARTO</h3>
				<p>
					<li>
						Diagnóstico médico respaldado por:
						<li>
							Una Hospitalización cuyo registro indique un infarto del miocardio
							dentro de un plazo de 24 horas antes de dicha Hospitalización.{" "}
						</li>
						<li>
							Un historial del típico dolor de pecho, indicativo de una
							enfermedad cardíaca isquémica.
						</li>
						<li>
							Cambios nuevos y relevantes en el electrocardiograma ECG, y/o
							aumento en las enzimas cardiacas y/o biomarcadores cardiacos por
							sobre los valores normales de laboratorio y que sean indicativos y
							compatibles con un evento agudo.
						</li>
						<li>
							Historia del dolor torácico típico. Electrocardiograma (ECG), con
							cambios nuevos que demuestran un infarto.
						</li>
						<li>Diagnóstico de elevación de enzimas cardiacas CPK-MB. </li>
						<li>Diagnóstico de elevación de la Troponina (T o I). </li>
						<li>
							Una fracción de la eyección ventricular izquierda menor al 50%,
							medida tres (3) meses o más después del evento.{" "}
						</li>
						<li>Elevación de biomarcadores cardiacos.</li>
					</li>
				</p>
				<h3>CÁNCER ELLA</h3>
				<p>
					<li>
						El Diagnóstico clínico deberá:
						<li>
							Ser elaborado por el Médico oncólogo, ginecólogo o
							ginecólogo-oncólogo, basado en el historial clínico del Asegurado,
							los exámenes efectuados y confirmados con el estudio
							histopatológico o citológico.
						</li>
						<li>
							Basarse sobre el criterio aceptado de ser maligno, después de
							haber estudiado la composición histológica, estructura y
							comportamiento de lo que se sospecha pueda ser un tumor, un tejido
							o una muestra.
						</li>
						<li>
							Cambios nuevos y relevantes en el electrocardiograma ECG, y/o
							aumento en las enzimas cardiacas y/o biomarcadores cardiacos por
							sobre los valores normales de laboratorio y que sean indicativos y
							compatibles con un evento agudo.
						</li>
						<li>
							Respaldarse con una prueba patológica, es decir, con un documento
							que contenga los resultados positivos de las pruebas del
							diagnóstico para ser aceptadas como evidencia bajo los términos de
							este seguro, el cual deberá estar fechado y firmado por un Médico
							debidamente autorizado para ejercer la especialidad de oncología,
							osteopatía, patología o similar y dichas pruebas deberán estar
							sustentadas en los exámenes microscópicos de tejidos finos o
							preparaciones obtenidas del sistema óseo, hemático, linfático o
							similar.
						</li>
					</li>
				</p>
				<h3>CÁNCER ÉL</h3>
				<p>
					<li>
						El Diagnóstico clínico deberá:
						<li>
							Ser preparado por un médico oncólogo, urólogo o uro.-oncólogo
							basado en el historial clínico del Asegurado, los exámenes
							efectuados y confirmados con el estudio histopatológico o
							citológico.
						</li>
						<li>
							Basarse sobre el criterio aceptado de ser maligno, después de
							haber estudiado la composición histológica, estructura y
							comportamiento de lo que se sospecha pueda ser un tumor, un tejido
							o una muestra.
						</li>
						<li>
							Comprobarse en cirugía, endoscopía, radiología u otro método de
							imagen en el que se demuestre que existe evidencia de células
							malignas en material histológico o citológico con invasión
							neoplásica de tejidos o estructuras adyacentes.
						</li>
						<li>
							Respaldarse con una prueba patológica, es decir, con un documento
							que contenga los resultados positivos de las pruebas del
							diagnóstico para ser aceptadas como evidencia bajo los términos de
							este seguro, el cual deberá estar fechado y firmado por un Médico
							debidamente autorizado para ejercer la especialidad de oncología,
							osteopatía, patología o similar y dichas pruebas deberán estar
							sustentadas en los exámenes microscópicos de tejidos finos o
							preparaciones obtenidas del sistema óseo, hemático, linfático o
							similar.
						</li>
						<li>
							Se pagará la Suma Asegurada al momento de ser diagnosticada la
							Etapa T2b (el cáncer se encuentra en más de la mitad de un solo
							lado (izquierdo o derecho) de la próstata).
						</li>
					</li>
				</p>
			</>
		),
	},
	{
		key: "4",
		header: "Renovaciones",
		body: "Nuestra renovación es automatica, solo deberás confirmarla y pagarla para que de esta manera puedas continuar protegido. Baja nuestra app, en ella encontrarás notificaciones, calendarios.",
	},
];
const HOGAR = [
	{
		key: "0",
		header: "Descripción de Producto",
		body: (
			<>
				<h3>Descripción de Producto</h3>
				<p>
					<li>
						Los accidentes no avisan y suelen provocar gastos que no tienes
						contemplados, un descuido podría provocar alguna incendio. un seguro
						de hogar te ayuda a proteger tu patrimonio contra eventos como:
						terremotos, inundaciones, incendios, Robos, Roturas de cristales,
						etc.
					</li>
					<li>
						No necesitas ser dueño de la casa, si tú la rentas, puedes asegurar
						los bienes que si son tuyos como tu sala, tus joyas, tus equipos de
						sonido, lap top, en fin lo que conocemos como contenidos, y tú
						puedes decidir qué tipo de cobertura requieres, contra inundaciones,
						contra terremoto, contra robo, entre otras.
					</li>
				</p>
			</>
		),
	},
	{
		key: "1",
		header: "Pagar Póliza",
		body: "Debes tener a la mano cualquier tarjeta de crédito o débito visa o mastercard, que este previamente liberada por tu banco para compras en línea.",
	},
];
export default guias;
